import { useQuery } from "@tanstack/react-query";
import ticketsService from "services/admin/ticketsService";
import {
    CloseReasonsStatsParams,
    CloseReasonsStatsResponse,
} from "interfaces/entities/ticketStats";

type Options = { enabled?: boolean };

// Структура причин закрытия тикетов за окно (для виджета на /admin/stats).
export const useCloseReasonsStats = (
    params: CloseReasonsStatsParams = {},
    options: Options = {}
) => {
    const orgID = localStorage.getItem("orgID") || "";
    const { enabled = true } = options;

    return useQuery<CloseReasonsStatsResponse>({
        queryKey: ["tickets-close-reasons", orgID, params],
        queryFn: async () => {
            const response = await ticketsService.getCloseReasonsStats(params);
            return response.data;
        },
        enabled,
        staleTime: 5 * 60 * 1000,
        refetchOnWindowFocus: false,
    });
};
